var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnicloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 32,
    viewBox: "0 0 166 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7098 10.3469H28.1172V10.9214H28.7098V10.3469Z",
    fill: "#3AF3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8211 10.3469H27.2285V10.9214H27.8211V10.3469Z",
    fill: "#3AF3FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8211 11.2095H27.2285V11.784H27.8211V11.2095Z",
    fill: "#3FE0C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8211 12.0713H27.2285V12.6458H27.8211V12.0713Z",
    fill: "#3FE0C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8075 22.2727H28.2148V22.8472H28.8075V22.2727Z",
    fill: "#4BC671"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9325 11.2095H26.3398V11.784H26.9325V11.2095Z",
    fill: "#3FE0C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9325 12.0713H26.3398V12.6458H26.9325V12.0713Z",
    fill: "#3FE0C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9325 12.9341H26.3398V13.5086H26.9325V12.9341Z",
    fill: "#3FE0C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9188 23.1345H27.3262V23.709H27.9188V23.1345Z",
    fill: "#4BC671"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9188 24.8589H27.3262V25.4334H27.9188V24.8589Z",
    fill: "#4BC671"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9188 26.5835H27.3262V27.158H27.9188V26.5835Z",
    fill: "#39B54A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0438 11.2095H25.4512V11.784H26.0438V11.2095Z",
    fill: "#3FE0C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0438 12.0713H25.4512V12.6458H26.0438V12.0713Z",
    fill: "#3FE0C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0438 12.9341H25.4512V13.5086H26.0438V12.9341Z",
    fill: "#3FE0C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0438 13.7969H25.4512V14.3714H26.0438V13.7969Z",
    fill: "#3FE0C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 9.48511H24.5625V10.0596H25.1551V9.48511Z",
    fill: "#3AF3FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 10.3469H24.5625V10.9214H25.1551V10.3469Z",
    fill: "#3AF3FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 11.2095H24.5625V11.784H25.1551V11.2095Z",
    fill: "#3FE0C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 12.0713H24.5625V12.6458H25.1551V12.0713Z",
    fill: "#3FE0C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 12.9341H24.5625V13.5086H25.1551V12.9341Z",
    fill: "#3FE0C8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 13.7969H24.5625V14.3714H25.1551V13.7969Z",
    fill: "#3FE0C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 14.6584H24.5625V15.233H25.1551V14.6584Z",
    fill: "#3FE0C8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1414 25.7217H25.5488V26.2962H26.1414V25.7217Z",
    fill: "#39B54A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 8.62231H23.6738V9.19684H24.2664V8.62231Z",
    fill: "#3AF3FC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 9.48511H23.6738V10.0596H24.2664V9.48511Z",
    fill: "#3AF3FC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 10.3469H23.6738V10.9214H24.2664V10.3469Z",
    fill: "#3AF3FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 11.2095H23.6738V11.784H24.2664V11.2095Z",
    fill: "#3FE0C8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 12.0713H23.6738V12.6458H24.2664V12.0713Z",
    fill: "#3FE0C8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 12.9341H23.6738V13.5086H24.2664V12.9341Z",
    fill: "#3FE0C8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 13.7969H23.6738V14.3714H24.2664V13.7969Z",
    fill: "#3FE0C8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 14.6584H23.6738V15.233H24.2664V14.6584Z",
    fill: "#3FE0C8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 15.5212H23.6738V16.0958H24.2664V15.5212Z",
    fill: "#3FE0C8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 19.832H23.6738V20.4066H24.2664V19.832Z",
    fill: "#4AD398"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2664 20.6946H23.6738V21.2691H24.2664V20.6946Z",
    fill: "#4AD398"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 7.76074H22.7852V8.33527H23.3778V7.76074Z",
    fill: "#3AF3FC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 8.62231H22.7852V9.19684H23.3778V8.62231Z",
    fill: "#3AF3FC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 9.48511H22.7852V10.0596H23.3778V9.48511Z",
    fill: "#3AF3FC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 10.3469H22.7852V10.9214H23.3778V10.3469Z",
    fill: "#3AF3FC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 11.2095H22.7852V11.784H23.3778V11.2095Z",
    fill: "#3FE0C8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 12.0713H22.7852V12.6458H23.3778V12.0713Z",
    fill: "#3FE0C8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 12.9341H22.7852V13.5086H23.3778V12.9341Z",
    fill: "#3FE0C8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 13.7969H22.7852V14.3714H23.3778V13.7969Z",
    fill: "#3FE0C8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 14.6584H22.7852V15.233H23.3778V14.6584Z",
    fill: "#3FE0C8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 15.5212H22.7852V16.0958H23.3778V15.5212Z",
    fill: "#3FE0C8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 16.3831H22.7852V16.9576H23.3778V16.3831Z",
    fill: "#4AD398"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 17.2456H22.7852V17.8201H23.3778V17.2456Z",
    fill: "#4AD398"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 18.1074H22.7852V18.6819H23.3778V18.1074Z",
    fill: "#4AD398"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 18.9702H22.7852V19.5447H23.3778V18.9702Z",
    fill: "#4AD398"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 19.832H22.7852V20.4066H23.3778V19.832Z",
    fill: "#4AD398"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 20.6946H22.7852V21.2691H23.3778V20.6946Z",
    fill: "#4AD398"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3778 21.5574H22.7852V22.1319H23.3778V21.5574Z",
    fill: "#4BC671"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 6.03613H21.8965V6.61066H22.4891V6.03613Z",
    fill: "#3AF3FC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 6.89795H21.8965V7.47247H22.4891V6.89795Z",
    fill: "#3AF3FC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 7.76074H21.8965V8.33527H22.4891V7.76074Z",
    fill: "#3AF3FC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 8.62231H21.8965V9.19684H22.4891V8.62231Z",
    fill: "#3AF3FC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 9.48511H21.8965V10.0596H22.4891V9.48511Z",
    fill: "#3AF3FC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 10.3469H21.8965V10.9214H22.4891V10.3469Z",
    fill: "#3AF3FC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 11.2095H21.8965V11.784H22.4891V11.2095Z",
    fill: "#3FE0C8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 12.0713H21.8965V12.6458H22.4891V12.0713Z",
    fill: "#3FE0C8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 12.9341H21.8965V13.5086H22.4891V12.9341Z",
    fill: "#3FE0C8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 13.7969H21.8965V14.3714H22.4891V13.7969Z",
    fill: "#3FE0C8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 14.6584H21.8965V15.233H22.4891V14.6584Z",
    fill: "#3FE0C8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 15.5212H21.8965V16.0958H22.4891V15.5212Z",
    fill: "#3FE0C8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 16.3831H21.8965V16.9576H22.4891V16.3831Z",
    fill: "#4AD398"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 17.2456H21.8965V17.8201H22.4891V17.2456Z",
    fill: "#4AD398"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 18.1074H21.8965V18.6819H22.4891V18.1074Z",
    fill: "#4AD398"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 18.9702H21.8965V19.5447H22.4891V18.9702Z",
    fill: "#4AD398"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 19.832H21.8965V20.4066H22.4891V19.832Z",
    fill: "#4AD398"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 20.6946H21.8965V21.2691H22.4891V20.6946Z",
    fill: "#4AD398"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 21.5574H21.8965V22.1319H22.4891V21.5574Z",
    fill: "#4BC671"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4891 22.4192H21.8965V22.9937H22.4891V22.4192Z",
    fill: "#4BC671"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 4.31079H21.0059V4.88531H21.5985V4.31079Z",
    fill: "#3DC8F9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 5.17334H21.0059V5.74786H21.5985V5.17334Z",
    fill: "#3DC8F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 6.03613H21.0059V6.61066H21.5985V6.03613Z",
    fill: "#3AF3FC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 6.89795H21.0059V7.47247H21.5985V6.89795Z",
    fill: "#3AF3FC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 7.76074H21.0059V8.33527H21.5985V7.76074Z",
    fill: "#3AF3FC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 8.62231H21.0059V9.19684H21.5985V8.62231Z",
    fill: "#3AF3FC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 9.48511H21.0059V10.0596H21.5985V9.48511Z",
    fill: "#3AF3FC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 10.3469H21.0059V10.9214H21.5985V10.3469Z",
    fill: "#3AF3FC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 11.2095H21.0059V11.784H21.5985V11.2095Z",
    fill: "#3FE0C8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 12.0713H21.0059V12.6458H21.5985V12.0713Z",
    fill: "#3FE0C8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 12.9341H21.0059V13.5086H21.5985V12.9341Z",
    fill: "#3FE0C8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 13.7969H21.0059V14.3714H21.5985V13.7969Z",
    fill: "#3FE0C8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 14.6584H21.0059V15.233H21.5985V14.6584Z",
    fill: "#3FE0C8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 15.5212H21.0059V16.0958H21.5985V15.5212Z",
    fill: "#3FE0C8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 16.3831H21.0059V16.9576H21.5985V16.3831Z",
    fill: "#4AD398"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 17.2456H21.0059V17.8201H21.5985V17.2456Z",
    fill: "#4AD398"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 18.1074H21.0059V18.6819H21.5985V18.1074Z",
    fill: "#4AD398"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 18.9702H21.0059V19.5447H21.5985V18.9702Z",
    fill: "#4AD398"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 19.832H21.0059V20.4066H21.5985V19.832Z",
    fill: "#4AD398"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 20.6946H21.0059V21.2691H21.5985V20.6946Z",
    fill: "#4AD398"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 21.5574H21.0059V22.1319H21.5985V21.5574Z",
    fill: "#4BC671"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 22.4192H21.0059V22.9937H21.5985V22.4192Z",
    fill: "#4BC671"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 23.2817H21.0059V23.8563H21.5985V23.2817Z",
    fill: "#4BC671"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 24.1436H21.0059V24.7181H21.5985V24.1436Z",
    fill: "#4BC671"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 25.0063H21.0059V25.5809H21.5985V25.0063Z",
    fill: "#4BC671"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5985 25.8682H21.0059V26.4427H21.5985V25.8682Z",
    fill: "#39B54A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 2.58618H20.1191V3.1607H20.7118V2.58618Z",
    fill: "#3DC8F9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 3.44897H20.1191V4.0235H20.7118V3.44897Z",
    fill: "#3DC8F9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 4.31079H20.1191V4.88531H20.7118V4.31079Z",
    fill: "#3DC8F9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 5.17334H20.1191V5.74786H20.7118V5.17334Z",
    fill: "#3DC8F9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 6.03613H20.1191V6.61066H20.7118V6.03613Z",
    fill: "#3AF3FC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 6.89795H20.1191V7.47247H20.7118V6.89795Z",
    fill: "#3AF3FC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 7.76074H20.1191V8.33527H20.7118V7.76074Z",
    fill: "#3AF3FC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 8.62231H20.1191V9.19684H20.7118V8.62231Z",
    fill: "#3AF3FC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 9.48511H20.1191V10.0596H20.7118V9.48511Z",
    fill: "#3AF3FC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 10.3469H20.1191V10.9214H20.7118V10.3469Z",
    fill: "#3AF3FC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 11.2095H20.1191V11.784H20.7118V11.2095Z",
    fill: "#3FE0C8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 12.0713H20.1191V12.6458H20.7118V12.0713Z",
    fill: "#3FE0C8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 12.9341H20.1191V13.5086H20.7118V12.9341Z",
    fill: "#3FE0C8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 13.7969H20.1191V14.3714H20.7118V13.7969Z",
    fill: "#3FE0C8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 14.6584H20.1191V15.233H20.7118V14.6584Z",
    fill: "#3FE0C8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 15.5212H20.1191V16.0958H20.7118V15.5212Z",
    fill: "#3FE0C8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 16.3831H20.1191V16.9576H20.7118V16.3831Z",
    fill: "#4AD398"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 17.2456H20.1191V17.8201H20.7118V17.2456Z",
    fill: "#4AD398"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 18.1074H20.1191V18.6819H20.7118V18.1074Z",
    fill: "#4AD398"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 18.9702H20.1191V19.5447H20.7118V18.9702Z",
    fill: "#4AD398"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 19.832H20.1191V20.4066H20.7118V19.832Z",
    fill: "#4AD398"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 20.6946H20.1191V21.2691H20.7118V20.6946Z",
    fill: "#4AD398"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 21.5574H20.1191V22.1319H20.7118V21.5574Z",
    fill: "#4BC671"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 22.4192H20.1191V22.9937H20.7118V22.4192Z",
    fill: "#4BC671"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 23.2817H20.1191V23.8563H20.7118V23.2817Z",
    fill: "#4BC671"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 24.1436H20.1191V24.7181H20.7118V24.1436Z",
    fill: "#4BC671"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 25.0063H20.1191V25.5809H20.7118V25.0063Z",
    fill: "#4BC671"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7118 25.8682H20.1191V26.4427H20.7118V25.8682Z",
    fill: "#39B54A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 2.58618H19.2285V3.1607H19.8211V2.58618Z",
    fill: "#3DC8F9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 3.44897H19.2285V4.0235H19.8211V3.44897Z",
    fill: "#3DC8F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 4.31079H19.2285V4.88531H19.8211V4.31079Z",
    fill: "#3DC8F9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 5.17334H19.2285V5.74786H19.8211V5.17334Z",
    fill: "#3DC8F9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 6.03613H19.2285V6.61066H19.8211V6.03613Z",
    fill: "#3AF3FC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 6.89795H19.2285V7.47247H19.8211V6.89795Z",
    fill: "#3AF3FC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 7.76074H19.2285V8.33527H19.8211V7.76074Z",
    fill: "#3AF3FC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 8.62231H19.2285V9.19684H19.8211V8.62231Z",
    fill: "#3AF3FC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 9.48511H19.2285V10.0596H19.8211V9.48511Z",
    fill: "#3AF3FC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 10.3469H19.2285V10.9214H19.8211V10.3469Z",
    fill: "#3AF3FC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 11.2095H19.2285V11.784H19.8211V11.2095Z",
    fill: "#3FE0C8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 12.0713H19.2285V12.6458H19.8211V12.0713Z",
    fill: "#3FE0C8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 12.9341H19.2285V13.5086H19.8211V12.9341Z",
    fill: "#3FE0C8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 13.7969H19.2285V14.3714H19.8211V13.7969Z",
    fill: "#3FE0C8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 14.6584H19.2285V15.233H19.8211V14.6584Z",
    fill: "#3FE0C8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 15.5212H19.2285V16.0958H19.8211V15.5212Z",
    fill: "#3FE0C8"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 16.3831H19.2285V16.9576H19.8211V16.3831Z",
    fill: "#4AD398"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 17.2456H19.2285V17.8201H19.8211V17.2456Z",
    fill: "#4AD398"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 18.1074H19.2285V18.6819H19.8211V18.1074Z",
    fill: "#4AD398"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 18.9702H19.2285V19.5447H19.8211V18.9702Z",
    fill: "#4AD398"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 19.832H19.2285V20.4066H19.8211V19.832Z",
    fill: "#4AD398"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 20.6946H19.2285V21.2691H19.8211V20.6946Z",
    fill: "#4AD398"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 21.5574H19.2285V22.1319H19.8211V21.5574Z",
    fill: "#4BC671"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 22.4192H19.2285V22.9937H19.8211V22.4192Z",
    fill: "#4BC671"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 23.2817H19.2285V23.8563H19.8211V23.2817Z",
    fill: "#4BC671"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 24.1436H19.2285V24.7181H19.8211V24.1436Z",
    fill: "#4BC671"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 25.0063H19.2285V25.5809H19.8211V25.0063Z",
    fill: "#4BC671"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 25.8682H19.2285V26.4427H19.8211V25.8682Z",
    fill: "#39B54A"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8211 26.7307H19.2285V27.3052H19.8211V26.7307Z",
    fill: "#39B54A"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 2.58618H18.3418V3.1607H18.9344V2.58618Z",
    fill: "#3DC8F9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 3.44897H18.3418V4.0235H18.9344V3.44897Z",
    fill: "#3DC8F9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 4.31079H18.3418V4.88531H18.9344V4.31079Z",
    fill: "#3DC8F9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 5.17334H18.3418V5.74786H18.9344V5.17334Z",
    fill: "#3DC8F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 6.03613H18.3418V6.61066H18.9344V6.03613Z",
    fill: "#3AF3FC"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 6.89795H18.3418V7.47247H18.9344V6.89795Z",
    fill: "#3AF3FC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 7.76074H18.3418V8.33527H18.9344V7.76074Z",
    fill: "#3AF3FC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 8.62231H18.3418V9.19684H18.9344V8.62231Z",
    fill: "#3AF3FC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 9.48511H18.3418V10.0596H18.9344V9.48511Z",
    fill: "#3AF3FC"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 10.3469H18.3418V10.9214H18.9344V10.3469Z",
    fill: "#3AF3FC"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 11.2095H18.3418V11.784H18.9344V11.2095Z",
    fill: "#3FE0C8"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 12.0713H18.3418V12.6458H18.9344V12.0713Z",
    fill: "#3FE0C8"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 12.9341H18.3418V13.5086H18.9344V12.9341Z",
    fill: "#3FE0C8"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 13.7969H18.3418V14.3714H18.9344V13.7969Z",
    fill: "#3FE0C8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 14.6584H18.3418V15.233H18.9344V14.6584Z",
    fill: "#3FE0C8"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 15.5212H18.3418V16.0958H18.9344V15.5212Z",
    fill: "#3FE0C8"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 16.3831H18.3418V16.9576H18.9344V16.3831Z",
    fill: "#4AD398"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 17.2456H18.3418V17.8201H18.9344V17.2456Z",
    fill: "#4AD398"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 18.1074H18.3418V18.6819H18.9344V18.1074Z",
    fill: "#4AD398"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 18.9702H18.3418V19.5447H18.9344V18.9702Z",
    fill: "#4AD398"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 19.832H18.3418V20.4066H18.9344V19.832Z",
    fill: "#4AD398"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 20.6946H18.3418V21.2691H18.9344V20.6946Z",
    fill: "#4AD398"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 21.5574H18.3418V22.1319H18.9344V21.5574Z",
    fill: "#4BC671"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 22.4192H18.3418V22.9937H18.9344V22.4192Z",
    fill: "#4BC671"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 23.2817H18.3418V23.8563H18.9344V23.2817Z",
    fill: "#4BC671"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 24.1436H18.3418V24.7181H18.9344V24.1436Z",
    fill: "#4BC671"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 25.0063H18.3418V25.5809H18.9344V25.0063Z",
    fill: "#4BC671"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 25.8682H18.3418V26.4427H18.9344V25.8682Z",
    fill: "#39B54A"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 26.7307H18.3418V27.3052H18.9344V26.7307Z",
    fill: "#39B54A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 27.5925H18.3418V28.1671H18.9344V27.5925Z",
    fill: "#39B54A"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 1.72461H17.4512V2.29913H18.0438V1.72461Z",
    fill: "#3DC8F9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 2.58618H17.4512V3.1607H18.0438V2.58618Z",
    fill: "#3DC8F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 3.44897H17.4512V4.0235H18.0438V3.44897Z",
    fill: "#3DC8F9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 4.31079H17.4512V4.88531H18.0438V4.31079Z",
    fill: "#3DC8F9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 5.17334H17.4512V5.74786H18.0438V5.17334Z",
    fill: "#3DC8F9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 6.03613H17.4512V6.61066H18.0438V6.03613Z",
    fill: "#3AF3FC"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 6.89795H17.4512V7.47247H18.0438V6.89795Z",
    fill: "#3AF3FC"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 7.76074H17.4512V8.33527H18.0438V7.76074Z",
    fill: "#3AF3FC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 8.62231H17.4512V9.19684H18.0438V8.62231Z",
    fill: "#3AF3FC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 9.48511H17.4512V10.0596H18.0438V9.48511Z",
    fill: "#3AF3FC"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 10.3469H17.4512V10.9214H18.0438V10.3469Z",
    fill: "#3AF3FC"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 11.2095H17.4512V11.784H18.0438V11.2095Z",
    fill: "#3FE0C8"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 12.0713H17.4512V12.6458H18.0438V12.0713Z",
    fill: "#3FE0C8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 12.9341H17.4512V13.5086H18.0438V12.9341Z",
    fill: "#3FE0C8"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 13.7969H17.4512V14.3714H18.0438V13.7969Z",
    fill: "#3FE0C8"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 14.6584H17.4512V15.233H18.0438V14.6584Z",
    fill: "#3FE0C8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 15.5212H17.4512V16.0958H18.0438V15.5212Z",
    fill: "#3FE0C8"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 16.3831H17.4512V16.9576H18.0438V16.3831Z",
    fill: "#4AD398"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 17.2456H17.4512V17.8201H18.0438V17.2456Z",
    fill: "#4AD398"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 18.1074H17.4512V18.6819H18.0438V18.1074Z",
    fill: "#4AD398"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 18.9702H17.4512V19.5447H18.0438V18.9702Z",
    fill: "#4AD398"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 19.832H17.4512V20.4066H18.0438V19.832Z",
    fill: "#4AD398"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 20.6946H17.4512V21.2691H18.0438V20.6946Z",
    fill: "#4AD398"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 21.5574H17.4512V22.1319H18.0438V21.5574Z",
    fill: "#4BC671"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 22.4192H17.4512V22.9937H18.0438V22.4192Z",
    fill: "#4BC671"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 23.2817H17.4512V23.8563H18.0438V23.2817Z",
    fill: "#4BC671"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 24.1436H17.4512V24.7181H18.0438V24.1436Z",
    fill: "#4BC671"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 25.0063H17.4512V25.5809H18.0438V25.0063Z",
    fill: "#4BC671"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 25.8682H17.4512V26.4427H18.0438V25.8682Z",
    fill: "#39B54A"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 26.7307H17.4512V27.3052H18.0438V26.7307Z",
    fill: "#39B54A"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 27.5925H17.4512V28.1671H18.0438V27.5925Z",
    fill: "#39B54A"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0438 28.4553H17.4512V29.0298H18.0438V28.4553Z",
    fill: "#39B54A"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 1.72461H16.5645V2.29913H17.1571V1.72461Z",
    fill: "#3DC8F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 2.58618H16.5645V3.1607H17.1571V2.58618Z",
    fill: "#3DC8F9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 3.44897H16.5645V4.0235H17.1571V3.44897Z",
    fill: "#3DC8F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 4.31079H16.5645V4.88531H17.1571V4.31079Z",
    fill: "#3DC8F9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 5.17334H16.5645V5.74786H17.1571V5.17334Z",
    fill: "#3DC8F9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 6.03613H16.5645V6.61066H17.1571V6.03613Z",
    fill: "#3AF3FC"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 6.89795H16.5645V7.47247H17.1571V6.89795Z",
    fill: "#3AF3FC"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 7.76074H16.5645V8.33527H17.1571V7.76074Z",
    fill: "#3AF3FC"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 8.62231H16.5645V9.19684H17.1571V8.62231Z",
    fill: "#3AF3FC"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 9.48511H16.5645V10.0596H17.1571V9.48511Z",
    fill: "#3AF3FC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 10.3469H16.5645V10.9214H17.1571V10.3469Z",
    fill: "#3AF3FC"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 11.2095H16.5645V11.784H17.1571V11.2095Z",
    fill: "#3FE0C8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 12.0713H16.5645V12.6458H17.1571V12.0713Z",
    fill: "#3FE0C8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 12.9341H16.5645V13.5086H17.1571V12.9341Z",
    fill: "#3FE0C8"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 13.7969H16.5645V14.3714H17.1571V13.7969Z",
    fill: "#3FE0C8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 14.6584H16.5645V15.233H17.1571V14.6584Z",
    fill: "#3FE0C8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 15.5212H16.5645V16.0958H17.1571V15.5212Z",
    fill: "#3FE0C8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 16.3831H16.5645V16.9576H17.1571V16.3831Z",
    fill: "#4AD398"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 17.2456H16.5645V17.8201H17.1571V17.2456Z",
    fill: "#4AD398"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 18.1074H16.5645V18.6819H17.1571V18.1074Z",
    fill: "#4AD398"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 18.9702H16.5645V19.5447H17.1571V18.9702Z",
    fill: "#4AD398"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 19.832H16.5645V20.4066H17.1571V19.832Z",
    fill: "#4AD398"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 20.6946H16.5645V21.2691H17.1571V20.6946Z",
    fill: "#4AD398"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 21.5574H16.5645V22.1319H17.1571V21.5574Z",
    fill: "#4BC671"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 22.4192H16.5645V22.9937H17.1571V22.4192Z",
    fill: "#4BC671"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 23.2817H16.5645V23.8563H17.1571V23.2817Z",
    fill: "#4BC671"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 24.1436H16.5645V24.7181H17.1571V24.1436Z",
    fill: "#4BC671"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 25.0063H16.5645V25.5809H17.1571V25.0063Z",
    fill: "#4BC671"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 25.8682H16.5645V26.4427H17.1571V25.8682Z",
    fill: "#39B54A"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 26.7307H16.5645V27.3052H17.1571V26.7307Z",
    fill: "#39B54A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 27.5925H16.5645V28.1671H17.1571V27.5925Z",
    fill: "#39B54A"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1571 28.4553H16.5645V29.0298H17.1571V28.4553Z",
    fill: "#39B54A"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 1.72461H15.6738V2.29913H16.2664V1.72461Z",
    fill: "#3DC8F9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 2.58618H15.6738V3.1607H16.2664V2.58618Z",
    fill: "#3DC8F9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 3.44897H15.6738V4.0235H16.2664V3.44897Z",
    fill: "#3DC8F9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 4.31079H15.6738V4.88531H16.2664V4.31079Z",
    fill: "#3DC8F9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 5.17334H15.6738V5.74786H16.2664V5.17334Z",
    fill: "#3DC8F9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 6.03613H15.6738V6.61066H16.2664V6.03613Z",
    fill: "#3AF3FC"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 6.89795H15.6738V7.47247H16.2664V6.89795Z",
    fill: "#3AF3FC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 7.76074H15.6738V8.33527H16.2664V7.76074Z",
    fill: "#3AF3FC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 8.62231H15.6738V9.19684H16.2664V8.62231Z",
    fill: "#3AF3FC"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 9.48511H15.6738V10.0596H16.2664V9.48511Z",
    fill: "#3AF3FC"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 10.3469H15.6738V10.9214H16.2664V10.3469Z",
    fill: "#3AF3FC"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 11.2095H15.6738V11.784H16.2664V11.2095Z",
    fill: "#3FE0C8"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 12.0713H15.6738V12.6458H16.2664V12.0713Z",
    fill: "#3FE0C8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 12.9341H15.6738V13.5086H16.2664V12.9341Z",
    fill: "#3FE0C8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 13.7969H15.6738V14.3714H16.2664V13.7969Z",
    fill: "#3FE0C8"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 14.6584H15.6738V15.233H16.2664V14.6584Z",
    fill: "#3FE0C8"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 15.5212H15.6738V16.0958H16.2664V15.5212Z",
    fill: "#3FE0C8"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 16.3831H15.6738V16.9576H16.2664V16.3831Z",
    fill: "#4AD398"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 17.2456H15.6738V17.8201H16.2664V17.2456Z",
    fill: "#4AD398"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 18.1074H15.6738V18.6819H16.2664V18.1074Z",
    fill: "#4AD398"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 18.9702H15.6738V19.5447H16.2664V18.9702Z",
    fill: "#4AD398"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 19.832H15.6738V20.4066H16.2664V19.832Z",
    fill: "#4AD398"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 20.6946H15.6738V21.2691H16.2664V20.6946Z",
    fill: "#4AD398"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 21.5574H15.6738V22.1319H16.2664V21.5574Z",
    fill: "#4BC671"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 22.4192H15.6738V22.9937H16.2664V22.4192Z",
    fill: "#4BC671"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 23.2817H15.6738V23.8563H16.2664V23.2817Z",
    fill: "#4BC671"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 24.1436H15.6738V24.7181H16.2664V24.1436Z",
    fill: "#4BC671"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 25.0063H15.6738V25.5809H16.2664V25.0063Z",
    fill: "#4BC671"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 25.8682H15.6738V26.4427H16.2664V25.8682Z",
    fill: "#39B54A"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 26.7307H15.6738V27.3052H16.2664V26.7307Z",
    fill: "#39B54A"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 27.5925H15.6738V28.1671H16.2664V27.5925Z",
    fill: "#39B54A"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2664 28.4553H15.6738V29.0298H16.2664V28.4553Z",
    fill: "#39B54A"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 2.58618H14.7871V3.1607H15.3797V2.58618Z",
    fill: "#3DC8F9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 3.44897H14.7871V4.0235H15.3797V3.44897Z",
    fill: "#3DC8F9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 4.31079H14.7871V4.88531H15.3797V4.31079Z",
    fill: "#3DC8F9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 5.17334H14.7871V5.74786H15.3797V5.17334Z",
    fill: "#3DC8F9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 6.03613H14.7871V6.61066H15.3797V6.03613Z",
    fill: "#3AF3FC"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 6.89795H14.7871V7.47247H15.3797V6.89795Z",
    fill: "#3AF3FC"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 7.76074H14.7871V8.33527H15.3797V7.76074Z",
    fill: "#3AF3FC"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 8.62231H14.7871V9.19684H15.3797V8.62231Z",
    fill: "#3AF3FC"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 9.48511H14.7871V10.0596H15.3797V9.48511Z",
    fill: "#3AF3FC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 10.3469H14.7871V10.9214H15.3797V10.3469Z",
    fill: "#3AF3FC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 11.2095H14.7871V11.784H15.3797V11.2095Z",
    fill: "#3FE0C8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 12.0713H14.7871V12.6458H15.3797V12.0713Z",
    fill: "#3FE0C8"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 12.9341H14.7871V13.5086H15.3797V12.9341Z",
    fill: "#3FE0C8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 13.7969H14.7871V14.3714H15.3797V13.7969Z",
    fill: "#3FE0C8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 14.6584H14.7871V15.233H15.3797V14.6584Z",
    fill: "#3FE0C8"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 15.5212H14.7871V16.0958H15.3797V15.5212Z",
    fill: "#3FE0C8"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 16.3831H14.7871V16.9576H15.3797V16.3831Z",
    fill: "#4AD398"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 17.2456H14.7871V17.8201H15.3797V17.2456Z",
    fill: "#4AD398"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 18.1074H14.7871V18.6819H15.3797V18.1074Z",
    fill: "#4AD398"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 18.9702H14.7871V19.5447H15.3797V18.9702Z",
    fill: "#4AD398"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 19.832H14.7871V20.4066H15.3797V19.832Z",
    fill: "#4AD398"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 20.6946H14.7871V21.2691H15.3797V20.6946Z",
    fill: "#4AD398"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 21.5574H14.7871V22.1319H15.3797V21.5574Z",
    fill: "#4BC671"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 22.4192H14.7871V22.9937H15.3797V22.4192Z",
    fill: "#4BC671"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 23.2817H14.7871V23.8563H15.3797V23.2817Z",
    fill: "#4BC671"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 24.1436H14.7871V24.7181H15.3797V24.1436Z",
    fill: "#4BC671"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 25.0063H14.7871V25.5809H15.3797V25.0063Z",
    fill: "#4BC671"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 25.8682H14.7871V26.4427H15.3797V25.8682Z",
    fill: "#39B54A"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 26.7307H14.7871V27.3052H15.3797V26.7307Z",
    fill: "#39B54A"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3797 27.5925H14.7871V28.1671H15.3797V27.5925Z",
    fill: "#39B54A"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 2.58618H13.8965V3.1607H14.4891V2.58618Z",
    fill: "#3DC8F9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 3.44897H13.8965V4.0235H14.4891V3.44897Z",
    fill: "#3DC8F9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 4.31079H13.8965V4.88531H14.4891V4.31079Z",
    fill: "#3DC8F9"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 5.17334H13.8965V5.74786H14.4891V5.17334Z",
    fill: "#3DC8F9"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 6.03613H13.8965V6.61066H14.4891V6.03613Z",
    fill: "#3AF3FC"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 6.89795H13.8965V7.47247H14.4891V6.89795Z",
    fill: "#3AF3FC"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 7.76074H13.8965V8.33527H14.4891V7.76074Z",
    fill: "#3AF3FC"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 8.62231H13.8965V9.19684H14.4891V8.62231Z",
    fill: "#3AF3FC"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 9.48511H13.8965V10.0596H14.4891V9.48511Z",
    fill: "#3AF3FC"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 10.3469H13.8965V10.9214H14.4891V10.3469Z",
    fill: "#3AF3FC"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 11.2095H13.8965V11.784H14.4891V11.2095Z",
    fill: "#3FE0C8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 12.0713H13.8965V12.6458H14.4891V12.0713Z",
    fill: "#3FE0C8"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 12.9341H13.8965V13.5086H14.4891V12.9341Z",
    fill: "#3FE0C8"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 13.7969H13.8965V14.3714H14.4891V13.7969Z",
    fill: "#3FE0C8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 14.6584H13.8965V15.233H14.4891V14.6584Z",
    fill: "#3FE0C8"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 15.5212H13.8965V16.0958H14.4891V15.5212Z",
    fill: "#3FE0C8"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 16.3831H13.8965V16.9576H14.4891V16.3831Z",
    fill: "#4AD398"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 17.2456H13.8965V17.8201H14.4891V17.2456Z",
    fill: "#4AD398"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 18.1074H13.8965V18.6819H14.4891V18.1074Z",
    fill: "#4AD398"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 18.9702H13.8965V19.5447H14.4891V18.9702Z",
    fill: "#4AD398"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 19.832H13.8965V20.4066H14.4891V19.832Z",
    fill: "#4AD398"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 20.6946H13.8965V21.2691H14.4891V20.6946Z",
    fill: "#4AD398"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 21.5574H13.8965V22.1319H14.4891V21.5574Z",
    fill: "#4BC671"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 22.4192H13.8965V22.9937H14.4891V22.4192Z",
    fill: "#4BC671"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 23.2817H13.8965V23.8563H14.4891V23.2817Z",
    fill: "#4BC671"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 24.1436H13.8965V24.7181H14.4891V24.1436Z",
    fill: "#4BC671"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 25.0063H13.8965V25.5809H14.4891V25.0063Z",
    fill: "#4BC671"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4891 25.8682H13.8965V26.4427H14.4891V25.8682Z",
    fill: "#39B54A"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 1.72461H13.0078V2.29913H13.6004V1.72461Z",
    fill: "#3DC8F9"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 2.58618H13.0078V3.1607H13.6004V2.58618Z",
    fill: "#3DC8F9"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 3.44897H13.0078V4.0235H13.6004V3.44897Z",
    fill: "#3DC8F9"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 4.31079H13.0078V4.88531H13.6004V4.31079Z",
    fill: "#3DC8F9"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 5.17334H13.0078V5.74786H13.6004V5.17334Z",
    fill: "#3DC8F9"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 6.03613H13.0078V6.61066H13.6004V6.03613Z",
    fill: "#3AF3FC"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 6.89795H13.0078V7.47247H13.6004V6.89795Z",
    fill: "#3AF3FC"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 7.76074H13.0078V8.33527H13.6004V7.76074Z",
    fill: "#3AF3FC"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 8.62231H13.0078V9.19684H13.6004V8.62231Z",
    fill: "#3AF3FC"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 9.48511H13.0078V10.0596H13.6004V9.48511Z",
    fill: "#3AF3FC"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 10.3469H13.0078V10.9214H13.6004V10.3469Z",
    fill: "#3AF3FC"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 11.2095H13.0078V11.784H13.6004V11.2095Z",
    fill: "#3FE0C8"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 12.0713H13.0078V12.6458H13.6004V12.0713Z",
    fill: "#3FE0C8"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 12.9341H13.0078V13.5086H13.6004V12.9341Z",
    fill: "#3FE0C8"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 13.7969H13.0078V14.3714H13.6004V13.7969Z",
    fill: "#3FE0C8"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 14.6584H13.0078V15.233H13.6004V14.6584Z",
    fill: "#3FE0C8"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 15.5212H13.0078V16.0958H13.6004V15.5212Z",
    fill: "#3FE0C8"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 16.3831H13.0078V16.9576H13.6004V16.3831Z",
    fill: "#4AD398"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 17.2456H13.0078V17.8201H13.6004V17.2456Z",
    fill: "#4AD398"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 18.1074H13.0078V18.6819H13.6004V18.1074Z",
    fill: "#4AD398"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 18.9702H13.0078V19.5447H13.6004V18.9702Z",
    fill: "#4AD398"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 19.832H13.0078V20.4066H13.6004V19.832Z",
    fill: "#4AD398"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 20.6946H13.0078V21.2691H13.6004V20.6946Z",
    fill: "#4AD398"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 21.5574H13.0078V22.1319H13.6004V21.5574Z",
    fill: "#4BC671"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 22.4192H13.0078V22.9937H13.6004V22.4192Z",
    fill: "#4BC671"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 23.2817H13.0078V23.8563H13.6004V23.2817Z",
    fill: "#4BC671"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 1.72461H12.1191V2.29913H12.7118V1.72461Z",
    fill: "#3DC8F9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 2.58618H12.1191V3.1607H12.7118V2.58618Z",
    fill: "#3DC8F9"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 3.44897H12.1191V4.0235H12.7118V3.44897Z",
    fill: "#3DC8F9"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 4.31079H12.1191V4.88531H12.7118V4.31079Z",
    fill: "#3DC8F9"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 5.17334H12.1191V5.74786H12.7118V5.17334Z",
    fill: "#3DC8F9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 6.03613H12.1191V6.61066H12.7118V6.03613Z",
    fill: "#3AF3FC"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 6.89795H12.1191V7.47247H12.7118V6.89795Z",
    fill: "#3AF3FC"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 7.76074H12.1191V8.33527H12.7118V7.76074Z",
    fill: "#3AF3FC"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 8.62231H12.1191V9.19684H12.7118V8.62231Z",
    fill: "#3AF3FC"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 9.48511H12.1191V10.0596H12.7118V9.48511Z",
    fill: "#3AF3FC"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 10.3469H12.1191V10.9214H12.7118V10.3469Z",
    fill: "#3AF3FC"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 11.2095H12.1191V11.784H12.7118V11.2095Z",
    fill: "#3FE0C8"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 12.0713H12.1191V12.6458H12.7118V12.0713Z",
    fill: "#3FE0C8"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 12.9341H12.1191V13.5086H12.7118V12.9341Z",
    fill: "#3FE0C8"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 13.7969H12.1191V14.3714H12.7118V13.7969Z",
    fill: "#3FE0C8"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 14.6584H12.1191V15.233H12.7118V14.6584Z",
    fill: "#3FE0C8"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 15.5212H12.1191V16.0958H12.7118V15.5212Z",
    fill: "#3FE0C8"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 16.3831H12.1191V16.9576H12.7118V16.3831Z",
    fill: "#4AD398"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 21.5574H12.1191V22.1319H12.7118V21.5574Z",
    fill: "#4BC671"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 0H11.2305V0.574524H11.8231V0Z",
    fill: "#3DC8F9"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 0.861816H11.2305V1.43634H11.8231V0.861816Z",
    fill: "#3DC8F9"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 1.72461H11.2305V2.29913H11.8231V1.72461Z",
    fill: "#3DC8F9"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 2.58618H11.2305V3.1607H11.8231V2.58618Z",
    fill: "#3DC8F9"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 3.44897H11.2305V4.0235H11.8231V3.44897Z",
    fill: "#3DC8F9"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 4.31079H11.2305V4.88531H11.8231V4.31079Z",
    fill: "#3DC8F9"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 5.17334H11.2305V5.74786H11.8231V5.17334Z",
    fill: "#3DC8F9"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 6.03613H11.2305V6.61066H11.8231V6.03613Z",
    fill: "#3AF3FC"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 6.89795H11.2305V7.47247H11.8231V6.89795Z",
    fill: "#3AF3FC"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 7.76074H11.2305V8.33527H11.8231V7.76074Z",
    fill: "#3AF3FC"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 8.62231H11.2305V9.19684H11.8231V8.62231Z",
    fill: "#3AF3FC"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 9.48511H11.2305V10.0596H11.8231V9.48511Z",
    fill: "#3AF3FC"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 10.3469H11.2305V10.9214H11.8231V10.3469Z",
    fill: "#3AF3FC"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 11.2095H11.2305V11.784H11.8231V11.2095Z",
    fill: "#3FE0C8"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 12.0713H11.2305V12.6458H11.8231V12.0713Z",
    fill: "#3FE0C8"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 12.9341H11.2305V13.5086H11.8231V12.9341Z",
    fill: "#3FE0C8"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 13.7969H11.2305V14.3714H11.8231V13.7969Z",
    fill: "#3FE0C8"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 14.6584H11.2305V15.233H11.8231V14.6584Z",
    fill: "#3FE0C8"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8231 15.5212H11.2305V16.0958H11.8231V15.5212Z",
    fill: "#3FE0C8"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 0H10.3418V0.574524H10.9344V0Z",
    fill: "#3DC8F9"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 0.861816H10.3418V1.43634H10.9344V0.861816Z",
    fill: "#3DC8F9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 1.72461H10.3418V2.29913H10.9344V1.72461Z",
    fill: "#3DC8F9"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 2.58618H10.3418V3.1607H10.9344V2.58618Z",
    fill: "#3DC8F9"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 3.44897H10.3418V4.0235H10.9344V3.44897Z",
    fill: "#3DC8F9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 4.31079H10.3418V4.88531H10.9344V4.31079Z",
    fill: "#3DC8F9"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 5.17334H10.3418V5.74786H10.9344V5.17334Z",
    fill: "#3DC8F9"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 6.03613H10.3418V6.61066H10.9344V6.03613Z",
    fill: "#3AF3FC"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 6.89795H10.3418V7.47247H10.9344V6.89795Z",
    fill: "#3AF3FC"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 7.76074H10.3418V8.33527H10.9344V7.76074Z",
    fill: "#3AF3FC"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 8.62231H10.3418V9.19684H10.9344V8.62231Z",
    fill: "#3AF3FC"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 9.48511H10.3418V10.0596H10.9344V9.48511Z",
    fill: "#3AF3FC"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 10.3469H10.3418V10.9214H10.9344V10.3469Z",
    fill: "#3AF3FC"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 11.2095H10.3418V11.784H10.9344V11.2095Z",
    fill: "#3FE0C8"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 12.0713H10.3418V12.6458H10.9344V12.0713Z",
    fill: "#3FE0C8"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9344 13.7969H10.3418V14.3714H10.9344V13.7969Z",
    fill: "#3FE0C8"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 0H9.45312V0.574524H10.0457V0Z",
    fill: "#3DC8F9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 0.861816H9.45312V1.43634H10.0457V0.861816Z",
    fill: "#3DC8F9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 1.72461H9.45312V2.29913H10.0457V1.72461Z",
    fill: "#3DC8F9"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 2.58618H9.45312V3.1607H10.0457V2.58618Z",
    fill: "#3DC8F9"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 3.44897H9.45312V4.0235H10.0457V3.44897Z",
    fill: "#3DC8F9"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 4.31079H9.45312V4.88531H10.0457V4.31079Z",
    fill: "#3DC8F9"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 5.17334H9.45312V5.74786H10.0457V5.17334Z",
    fill: "#3DC8F9"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 6.03613H9.45312V6.61066H10.0457V6.03613Z",
    fill: "#3AF3FC"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 6.89795H9.45312V7.47247H10.0457V6.89795Z",
    fill: "#3AF3FC"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 7.76074H9.45312V8.33527H10.0457V7.76074Z",
    fill: "#3AF3FC"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 8.62231H9.45312V9.19684H10.0457V8.62231Z",
    fill: "#3AF3FC"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 9.48511H9.45312V10.0596H10.0457V9.48511Z",
    fill: "#3AF3FC"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 10.3469H9.45312V10.9214H10.0457V10.3469Z",
    fill: "#3AF3FC"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 11.2095H9.45312V11.784H10.0457V11.2095Z",
    fill: "#3FE0C8"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0457 12.0713H9.45312V12.6458H10.0457V12.0713Z",
    fill: "#3FE0C8"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 0H8.56445V0.574524H9.15707V0Z",
    fill: "#3DC8F9"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 0.861816H8.56445V1.43634H9.15707V0.861816Z",
    fill: "#3DC8F9"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 1.72461H8.56445V2.29913H9.15707V1.72461Z",
    fill: "#3DC8F9"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 2.58618H8.56445V3.1607H9.15707V2.58618Z",
    fill: "#3DC8F9"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 3.44897H8.56445V4.0235H9.15707V3.44897Z",
    fill: "#3DC8F9"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 4.31079H8.56445V4.88531H9.15707V4.31079Z",
    fill: "#3DC8F9"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 5.17334H8.56445V5.74786H9.15707V5.17334Z",
    fill: "#3DC8F9"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 6.03613H8.56445V6.61066H9.15707V6.03613Z",
    fill: "#3AF3FC"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 6.89795H8.56445V7.47247H9.15707V6.89795Z",
    fill: "#3AF3FC"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 7.76074H8.56445V8.33527H9.15707V7.76074Z",
    fill: "#3AF3FC"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 8.62231H8.56445V9.19684H9.15707V8.62231Z",
    fill: "#3AF3FC"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 9.48511H8.56445V10.0596H9.15707V9.48511Z",
    fill: "#3AF3FC"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 10.3469H8.56445V10.9214H9.15707V10.3469Z",
    fill: "#3AF3FC"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15707 11.2095H8.56445V11.784H9.15707V11.2095Z",
    fill: "#3FE0C8"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 0H7.67578V0.574524H8.2684V0Z",
    fill: "#3DC8F9"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 0.861816H7.67578V1.43634H8.2684V0.861816Z",
    fill: "#3DC8F9"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 1.72461H7.67578V2.29913H8.2684V1.72461Z",
    fill: "#3DC8F9"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 2.58618H7.67578V3.1607H8.2684V2.58618Z",
    fill: "#3DC8F9"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 3.44897H7.67578V4.0235H8.2684V3.44897Z",
    fill: "#3DC8F9"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 4.31079H7.67578V4.88531H8.2684V4.31079Z",
    fill: "#3DC8F9"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 5.17334H7.67578V5.74786H8.2684V5.17334Z",
    fill: "#3DC8F9"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 6.03613H7.67578V6.61066H8.2684V6.03613Z",
    fill: "#3AF3FC"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 6.89795H7.67578V7.47247H8.2684V6.89795Z",
    fill: "#3AF3FC"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 7.76074H7.67578V8.33527H8.2684V7.76074Z",
    fill: "#3AF3FC"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 8.62231H7.67578V9.19684H8.2684V8.62231Z",
    fill: "#3AF3FC"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 9.48511H7.67578V10.0596H8.2684V9.48511Z",
    fill: "#3AF3FC"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 10.3469H7.67578V10.9214H8.2684V10.3469Z",
    fill: "#3AF3FC"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2684 11.2095H7.67578V11.784H8.2684V11.2095Z",
    fill: "#3FE0C8"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 0H6.78711V0.574524H7.37973V0Z",
    fill: "#3DC8F9"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 0.861816H6.78711V1.43634H7.37973V0.861816Z",
    fill: "#3DC8F9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 1.72461H6.78711V2.29913H7.37973V1.72461Z",
    fill: "#3DC8F9"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 2.58618H6.78711V3.1607H7.37973V2.58618Z",
    fill: "#3DC8F9"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 3.44897H6.78711V4.0235H7.37973V3.44897Z",
    fill: "#3DC8F9"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 4.31079H6.78711V4.88531H7.37973V4.31079Z",
    fill: "#3DC8F9"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 5.17334H6.78711V5.74786H7.37973V5.17334Z",
    fill: "#3DC8F9"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 6.03613H6.78711V6.61066H7.37973V6.03613Z",
    fill: "#3AF3FC"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 6.89795H6.78711V7.47247H7.37973V6.89795Z",
    fill: "#3AF3FC"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 7.76074H6.78711V8.33527H7.37973V7.76074Z",
    fill: "#3AF3FC"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 8.62231H6.78711V9.19684H7.37973V8.62231Z",
    fill: "#3AF3FC"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 9.48511H6.78711V10.0596H7.37973V9.48511Z",
    fill: "#3AF3FC"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 10.3469H6.78711V10.9214H7.37973V10.3469Z",
    fill: "#3AF3FC"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 11.2095H6.78711V11.784H7.37973V11.2095Z",
    fill: "#3FE0C8"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37973 12.0713H6.78711V12.6458H7.37973V12.0713Z",
    fill: "#3FE0C8"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 0H5.89844V0.574524H6.49106V0Z",
    fill: "#3DC8F9"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 0.861816H5.89844V1.43634H6.49106V0.861816Z",
    fill: "#3DC8F9"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 1.72461H5.89844V2.29913H6.49106V1.72461Z",
    fill: "#3DC8F9"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 2.58618H5.89844V3.1607H6.49106V2.58618Z",
    fill: "#3DC8F9"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 3.44897H5.89844V4.0235H6.49106V3.44897Z",
    fill: "#3DC8F9"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 4.31079H5.89844V4.88531H6.49106V4.31079Z",
    fill: "#3DC8F9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 5.17334H5.89844V5.74786H6.49106V5.17334Z",
    fill: "#3DC8F9"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 6.03613H5.89844V6.61066H6.49106V6.03613Z",
    fill: "#3AF3FC"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 6.89795H5.89844V7.47247H6.49106V6.89795Z",
    fill: "#3AF3FC"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 7.76074H5.89844V8.33527H6.49106V7.76074Z",
    fill: "#3AF3FC"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 8.62231H5.89844V9.19684H6.49106V8.62231Z",
    fill: "#3AF3FC"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 9.48511H5.89844V10.0596H6.49106V9.48511Z",
    fill: "#3AF3FC"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 10.3469H5.89844V10.9214H6.49106V10.3469Z",
    fill: "#3AF3FC"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 11.2095H5.89844V11.784H6.49106V11.2095Z",
    fill: "#3FE0C8"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49106 12.0713H5.89844V12.6458H6.49106V12.0713Z",
    fill: "#3FE0C8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 0.861816H5.00977V1.43634H5.60239V0.861816Z",
    fill: "#3DC8F9"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 1.72461H5.00977V2.29913H5.60239V1.72461Z",
    fill: "#3DC8F9"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 2.58618H5.00977V3.1607H5.60239V2.58618Z",
    fill: "#3DC8F9"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 3.44897H5.00977V4.0235H5.60239V3.44897Z",
    fill: "#3DC8F9"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 4.31079H5.00977V4.88531H5.60239V4.31079Z",
    fill: "#3DC8F9"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 5.17334H5.00977V5.74786H5.60239V5.17334Z",
    fill: "#3DC8F9"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 6.03613H5.00977V6.61066H5.60239V6.03613Z",
    fill: "#3AF3FC"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 6.89795H5.00977V7.47247H5.60239V6.89795Z",
    fill: "#3AF3FC"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 7.76074H5.00977V8.33527H5.60239V7.76074Z",
    fill: "#3AF3FC"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 8.62231H5.00977V9.19684H5.60239V8.62231Z",
    fill: "#3AF3FC"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 9.48511H5.00977V10.0596H5.60239V9.48511Z",
    fill: "#3AF3FC"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 10.3469H5.00977V10.9214H5.60239V10.3469Z",
    fill: "#3AF3FC"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 11.2095H5.00977V11.784H5.60239V11.2095Z",
    fill: "#3FE0C8"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60239 12.0713H5.00977V12.6458H5.60239V12.0713Z",
    fill: "#3FE0C8"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 1.72461H4.12109V2.29913H4.71371V1.72461Z",
    fill: "#3DC8F9"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 2.58618H4.12109V3.1607H4.71371V2.58618Z",
    fill: "#3DC8F9"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 3.44897H4.12109V4.0235H4.71371V3.44897Z",
    fill: "#3DC8F9"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 4.31079H4.12109V4.88531H4.71371V4.31079Z",
    fill: "#3DC8F9"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 5.17334H4.12109V5.74786H4.71371V5.17334Z",
    fill: "#3DC8F9"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 6.03613H4.12109V6.61066H4.71371V6.03613Z",
    fill: "#3AF3FC"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 6.89795H4.12109V7.47247H4.71371V6.89795Z",
    fill: "#3AF3FC"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 7.76074H4.12109V8.33527H4.71371V7.76074Z",
    fill: "#3AF3FC"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 8.62231H4.12109V9.19684H4.71371V8.62231Z",
    fill: "#3AF3FC"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 9.48511H4.12109V10.0596H4.71371V9.48511Z",
    fill: "#3AF3FC"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 10.3469H4.12109V10.9214H4.71371V10.3469Z",
    fill: "#3AF3FC"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 11.2095H4.12109V11.784H4.71371V11.2095Z",
    fill: "#3FE0C8"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71371 12.0713H4.12109V12.6458H4.71371V12.0713Z",
    fill: "#3FE0C8"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 2.58618H3.23242V3.1607H3.82504V2.58618Z",
    fill: "#3DC8F9"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 3.44897H3.23242V4.0235H3.82504V3.44897Z",
    fill: "#3DC8F9"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 4.31079H3.23242V4.88531H3.82504V4.31079Z",
    fill: "#3DC8F9"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 5.17334H3.23242V5.74786H3.82504V5.17334Z",
    fill: "#3DC8F9"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 6.03613H3.23242V6.61066H3.82504V6.03613Z",
    fill: "#3AF3FC"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 6.89795H3.23242V7.47247H3.82504V6.89795Z",
    fill: "#3AF3FC"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 7.76074H3.23242V8.33527H3.82504V7.76074Z",
    fill: "#3AF3FC"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 8.62231H3.23242V9.19684H3.82504V8.62231Z",
    fill: "#3AF3FC"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 9.48511H3.23242V10.0596H3.82504V9.48511Z",
    fill: "#3AF3FC"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 10.3469H3.23242V10.9214H3.82504V10.3469Z",
    fill: "#3AF3FC"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 11.2095H3.23242V11.784H3.82504V11.2095Z",
    fill: "#3FE0C8"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82504 12.0713H3.23242V12.6458H3.82504V12.0713Z",
    fill: "#3FE0C8"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 3.44897H2.34375V4.0235H2.93637V3.44897Z",
    fill: "#3DC8F9"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 4.31079H2.34375V4.88531H2.93637V4.31079Z",
    fill: "#3DC8F9"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 5.17334H2.34375V5.74786H2.93637V5.17334Z",
    fill: "#3DC8F9"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 6.03613H2.34375V6.61066H2.93637V6.03613Z",
    fill: "#3AF3FC"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 6.89795H2.34375V7.47247H2.93637V6.89795Z",
    fill: "#3AF3FC"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 7.76074H2.34375V8.33527H2.93637V7.76074Z",
    fill: "#3AF3FC"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 8.62231H2.34375V9.19684H2.93637V8.62231Z",
    fill: "#3AF3FC"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 9.48511H2.34375V10.0596H2.93637V9.48511Z",
    fill: "#3AF3FC"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 10.3469H2.34375V10.9214H2.93637V10.3469Z",
    fill: "#3AF3FC"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93637 11.2095H2.34375V11.784H2.93637V11.2095Z",
    fill: "#3FE0C8"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 4.31079H1.45508V4.88531H2.04769V4.31079Z",
    fill: "#3DC8F9"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 5.17334H1.45508V5.74786H2.04769V5.17334Z",
    fill: "#3DC8F9"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 6.03613H1.45508V6.61066H2.04769V6.03613Z",
    fill: "#3AF3FC"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 6.89795H1.45508V7.47247H2.04769V6.89795Z",
    fill: "#3AF3FC"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 7.76074H1.45508V8.33527H2.04769V7.76074Z",
    fill: "#3AF3FC"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 8.62231H1.45508V9.19684H2.04769V8.62231Z",
    fill: "#3AF3FC"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 9.48511H1.45508V10.0596H2.04769V9.48511Z",
    fill: "#3AF3FC"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 10.3469H1.45508V10.9214H2.04769V10.3469Z",
    fill: "#3AF3FC"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04769 11.2095H1.45508V11.784H2.04769V11.2095Z",
    fill: "#3FE0C8"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15903 5.17334H0.566406V5.74786H1.15903V5.17334Z",
    fill: "#3DC8F9"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15903 6.03613H0.566406V6.61066H1.15903V6.03613Z",
    fill: "#3AF3FC"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15903 6.89795H0.566406V7.47247H1.15903V6.89795Z",
    fill: "#3AF3FC"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15903 7.7605H0.566406V8.33502H1.15903V7.7605Z",
    fill: "#3AF3FC"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15903 8.62231H0.566406V9.19684H1.15903V8.62231Z",
    fill: "#3AF3FC"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15903 9.48511H0.566406V10.0596H1.15903V9.48511Z",
    fill: "#3AF3FC"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1727 25.7217H25.5801V26.2962H26.1727V25.7217Z",
    fill: "#39B54A"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8485 26.5808H27.2559V27.1553H27.8485V26.5808Z",
    fill: "#39B54A"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0399 23.1255H26.4473V23.7H27.0399V23.1255Z",
    fill: "#4BC671"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9149 23.1255H27.3223V23.7H27.9149V23.1255Z",
    fill: "#4BC671"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8114 22.2664H28.2188V22.8409H28.8114V22.2664Z",
    fill: "#4BC671"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9149 24.8525H27.3223V25.4271H27.9149V24.8525Z",
    fill: "#4BC671"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9188 23.9973H27.3262V24.5718H27.9188V23.9973Z",
    fill: "#4BC671"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0301 23.9973H26.4375V24.5718H27.0301V23.9973Z",
    fill: "#4BC671"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0301 24.8589H26.4375V25.4334H27.0301V24.8589Z",
    fill: "#4BC671"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0301 25.7217H26.4375V26.2962H27.0301V25.7217Z",
    fill: "#39B54A"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0301 26.5835H26.4375V27.158H27.0301V26.5835Z",
    fill: "#39B54A"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92519 16.6557C8.05449 16.5185 8.18753 16.383 8.33744 16.2621C8.48642 16.1403 8.64476 16.0212 8.83871 15.9394C8.88743 15.9194 8.93896 15.903 8.99049 15.8849C9.04577 15.8739 9.09918 15.8576 9.15727 15.853C9.27345 15.8403 9.39994 15.8521 9.51987 15.8939C9.63605 15.9385 9.74661 16.0067 9.82812 16.0885C9.9162 16.1685 9.98085 16.2585 10.0408 16.3485C10.2657 16.7139 10.3687 17.093 10.4615 17.4657C10.5533 17.8393 10.6105 18.212 10.6667 18.582C10.7726 19.3238 10.8447 20.0592 10.9206 20.7892C10.9946 21.5192 11.0733 22.2437 11.1689 22.96C11.2682 23.6755 11.3825 24.3827 11.5465 25.07C11.7048 25.7572 11.9119 26.4263 12.1873 27.0453C12.3251 27.3553 12.4862 27.6489 12.6633 27.9253L12.801 28.128L12.9472 28.3226L13.1112 28.5189L13.1918 28.618L13.277 28.7116L13.4475 28.8998L13.6274 29.0762C13.6865 29.1362 13.7483 29.1916 13.8111 29.2471C13.8738 29.3007 13.9329 29.3616 13.9994 29.4107L14.1943 29.5643L14.3967 29.7061C14.4622 29.757 14.5344 29.7952 14.6037 29.8398L14.7087 29.9052L14.8173 29.9625C15.3936 30.2761 16.041 30.4588 16.724 30.4906C17.4071 30.5261 18.1163 30.4097 18.8022 30.1888C19.4899 29.9679 20.1542 29.6416 20.7669 29.2371C20.9215 29.138 21.0658 29.0225 21.2157 28.9162C21.3675 28.8107 21.5081 28.6916 21.6495 28.5725C21.791 28.4535 21.9334 28.3362 22.0655 28.2062C22.1995 28.0789 22.3382 27.9553 22.4656 27.8217L22.8479 27.418C22.9753 27.2835 23.0906 27.1381 23.2124 26.9981L23.3913 26.7862L23.5637 26.5681C23.6771 26.4217 23.7933 26.2772 23.902 26.1272L24.228 25.6772C24.3367 25.5272 24.436 25.3708 24.54 25.2181C24.7508 24.9136 24.942 24.5963 25.1397 24.2836C25.2362 24.1264 25.3308 23.9664 25.4245 23.8073C25.5191 23.6482 25.6128 23.4891 25.7037 23.3273C25.8855 23.0055 26.0644 22.681 26.2396 22.3555C26.5957 21.7074 26.9274 21.0447 27.2656 20.3865L27.7678 19.3947L28.0189 18.8984C28.1004 18.7357 28.1791 18.5747 28.2531 18.4102C28.4012 18.083 28.5323 17.7493 28.641 17.4139C28.7535 17.0794 28.8425 16.7403 28.8931 16.4076C28.9184 16.2421 28.9324 16.0776 28.9305 15.923C28.9305 15.7703 28.9109 15.624 28.8743 15.5294C28.8575 15.4821 28.8359 15.4521 28.8256 15.4458C28.8228 15.4458 28.8209 15.4458 28.8209 15.4431C28.82 15.444 28.82 15.4458 28.8209 15.4449C28.82 15.4467 28.8228 15.4485 28.8209 15.4476C28.8134 15.4458 28.8059 15.444 28.7984 15.4412C28.7703 15.4349 28.7478 15.434 28.7179 15.4367C28.6879 15.4403 28.6476 15.4549 28.6026 15.4749C28.5089 15.5194 28.3965 15.603 28.2878 15.7094C28.1791 15.8149 28.0732 15.9385 27.973 16.0712C27.7715 16.3376 27.5916 16.6385 27.4258 16.9485C27.0941 17.5712 26.8168 18.2366 26.5685 18.912C26.3183 19.5883 26.1 20.2783 25.907 20.9756C25.5257 22.3719 25.2174 23.79 25.0188 25.2172C24.9682 25.5736 24.926 25.9308 24.8923 26.2881C24.8586 26.649 24.837 26.9899 24.8342 27.339C24.8305 27.6853 24.8501 28.0289 24.897 28.3644C24.9438 28.6998 25.0132 29.028 25.12 29.3371C25.3299 29.9552 25.7009 30.4961 26.2256 30.8015C26.4861 30.9552 26.7821 31.0543 27.096 31.087C27.4099 31.1224 27.7397 31.0924 28.0639 31.0161C28.7132 30.8543 29.3353 30.5061 29.8694 30.0525C30.4015 29.5943 30.8569 29.0362 31.2214 28.4225C31.9522 27.189 32.3185 25.7463 32.4029 24.2845C32.4047 24.2545 32.431 24.2309 32.4619 24.2327C32.49 24.2345 32.5125 24.2563 32.5144 24.2836C32.5378 24.6536 32.5481 25.0254 32.5331 25.3981C32.5153 25.7708 32.4778 26.1435 32.415 26.5144C32.2895 27.2553 32.0656 27.988 31.7283 28.678C31.3928 29.3689 30.9468 30.0198 30.3772 30.5743C29.8075 31.1252 29.1161 31.5933 28.3028 31.837C27.8971 31.9551 27.4623 32.0206 27.0201 31.9942C26.5788 31.9697 26.13 31.8533 25.7327 31.6397C25.536 31.5324 25.3467 31.4079 25.18 31.2624C25.0919 31.1933 25.0179 31.1124 24.9382 31.037C24.8661 30.9552 24.7883 30.877 24.7246 30.7906C24.4548 30.4516 24.2514 30.077 24.1043 29.6934C23.8073 28.9243 23.7005 28.1271 23.6846 27.3499C23.6808 27.2526 23.6818 27.1553 23.6827 27.0581C23.6846 26.9608 23.6827 26.8635 23.6883 26.7672L23.7015 26.4781L23.7211 26.1954C23.7502 25.819 23.7886 25.4445 23.8354 25.0709C24.0284 23.5782 24.3423 22.1082 24.7761 20.6692C25.2146 19.2311 25.7299 17.8121 26.4954 16.4612C26.6903 16.1248 26.9011 15.7921 27.1588 15.4712C27.2881 15.3112 27.4286 15.154 27.5935 15.004C27.7575 14.8549 27.9496 14.7104 28.2016 14.6022C28.33 14.5504 28.4714 14.5067 28.6317 14.4949C28.7909 14.4831 28.9596 14.504 29.1114 14.5558C29.1488 14.5695 29.1854 14.584 29.2219 14.5995C29.2622 14.6185 29.3063 14.644 29.3465 14.6676C29.385 14.6949 29.4234 14.7231 29.459 14.7531C29.4918 14.784 29.5236 14.8167 29.5527 14.8494C29.666 14.984 29.7279 15.124 29.7672 15.2512C29.8441 15.5085 29.8506 15.7349 29.8384 15.9485C29.8253 16.1621 29.7925 16.3639 29.7485 16.5603C29.5705 17.3412 29.2519 18.042 28.8799 18.7093C28.7872 18.8756 28.6888 19.0402 28.5895 19.2011L28.2962 19.6747L27.7097 20.6219L26.5329 22.5164L26.2368 22.9891L25.9361 23.4591C25.7412 23.7755 25.5313 24.0836 25.3336 24.3982C24.9232 25.02 24.5082 25.6381 24.0687 26.2417C23.6237 26.8417 23.1683 27.4353 22.6689 27.9989C22.1686 28.5607 21.6317 29.0962 21.0433 29.5889C20.4493 30.0752 19.7981 30.507 19.0823 30.8479C18.3684 31.187 17.5795 31.4306 16.7437 31.4952C16.3268 31.5288 15.8995 31.5088 15.477 31.4415C15.0563 31.3679 14.6412 31.247 14.2514 31.0743C13.4653 30.7352 12.7879 30.2125 12.2304 29.6216C12.0843 29.4771 11.9606 29.3189 11.8285 29.1662L11.6374 28.9162L11.4603 28.6589C11.2335 28.3126 11.0499 27.948 10.8897 27.5808C10.5692 26.8453 10.3706 26.0872 10.2216 25.3345C10.1486 24.9572 10.0933 24.58 10.0464 24.2036C9.99865 23.8273 9.96398 23.4518 9.93962 23.0773C9.88621 22.3282 9.86841 21.5837 9.86092 20.8438L9.85717 19.7383C9.85904 19.3711 9.85717 19.0056 9.85155 18.6429C9.84686 18.2802 9.83374 17.9193 9.8047 17.5657C9.79064 17.3884 9.76816 17.2148 9.73724 17.0457C9.70726 16.8766 9.66791 16.7121 9.60701 16.5676C9.54517 16.4239 9.4674 16.3021 9.35965 16.2358C9.25284 16.1721 9.09731 16.1558 8.93053 16.1976C8.76469 16.2358 8.5951 16.3094 8.43208 16.3948C8.26717 16.4794 8.1107 16.5821 7.95142 16.6839C7.94205 16.6903 7.92988 16.6876 7.92332 16.6785C7.91769 16.6712 7.91957 16.6612 7.92519 16.6548V16.6557Z",
    fill: "#3DC8F9"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8371 9.3H40.6371V18.02C40.6371 19.56 41.0571 20.98 43.1771 20.98C45.2571 20.98 45.6571 19.64 45.6571 18.02V9.3H48.4771V18.08C48.4771 20.96 47.2571 23.2 43.1171 23.2C39.0371 23.2 37.8371 21.02 37.8371 18.1V9.3ZM51.0249 23V15.88C51.0249 13.76 51.0049 13.12 50.9849 12.66H53.6249C53.6649 12.84 53.7249 13.5 53.7249 14C54.1449 13.2 55.1249 12.46 56.6049 12.46C58.7649 12.46 59.8649 13.84 59.8649 16.22V23H57.1449V16.74C57.1449 15.58 56.8649 14.7 55.5649 14.7C54.3449 14.7 53.7249 15.42 53.7249 17.24V23H51.0249ZM62.6507 23V12.66H65.3507V23H62.6507ZM62.6507 10.96V8.46H65.3507V10.96H62.6507ZM78.2441 19.26H79.3641C78.7241 21.48 77.0641 23.18 74.1041 23.18C70.0641 23.18 67.9441 19.98 67.9441 16.04C67.9441 12.26 70.0241 8.82 74.1241 8.82C77.1441 8.82 78.9241 10.5 79.3841 12.84H78.2641C77.6441 11.04 76.4641 9.84 74.0641 9.84C70.6041 9.84 69.1441 13 69.1441 16.02C69.1441 19 70.5841 22.14 74.1441 22.14C76.4041 22.14 77.5641 20.96 78.2441 19.26ZM83.2002 23H82.1602V8.28H83.2002V23ZM90.3571 12.76C93.0371 12.76 94.7971 14.84 94.7971 17.98C94.7971 20.78 93.2371 23.24 90.2571 23.24C87.5571 23.24 85.8571 21.02 85.8571 18C85.8571 15.14 87.4571 12.76 90.3571 12.76ZM90.2971 13.74C88.0371 13.74 86.9571 15.62 86.9571 18C86.9571 20.38 88.2371 22.28 90.3371 22.28C92.4771 22.28 93.6971 20.52 93.6971 18C93.6971 15.66 92.4971 13.74 90.2971 13.74ZM104.983 13V20.08C104.983 21.06 105.003 22.62 105.003 23H104.003C103.963 22.74 103.943 22.1 103.943 21.28C103.523 22.46 102.503 23.24 100.723 23.24C99.2826 23.24 97.4426 22.68 97.4426 19.62V13H98.4626V19.38C98.4626 20.84 98.9226 22.24 100.883 22.24C103.103 22.24 103.943 21 103.943 18.16V13H104.983ZM115.164 8.28H116.204V20.14C116.204 21.1 116.204 22.02 116.224 23H115.224C115.184 22.76 115.164 21.84 115.164 21.34C114.664 22.56 113.544 23.24 111.804 23.24C109.204 23.24 107.644 21.14 107.644 18.12C107.644 15.04 109.344 12.76 112.084 12.76C114.064 12.76 114.864 13.62 115.164 14.26V8.28ZM112.044 13.74C110.084 13.74 108.744 15.3 108.744 18.08C108.744 20.8 110.164 22.28 111.864 22.28C114.504 22.28 115.204 20.46 115.204 17.78C115.204 15.2 114.604 13.74 112.044 13.74Z",
    fill: "#3DC8F9"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M122.991 9H125.971L128.251 23H126.051L125.651 20.22V20.26H123.151L122.751 23H120.711L122.991 9ZM125.391 18.36L124.411 11.44H124.371L123.411 18.36H125.391ZM129.718 9H135.538V11H131.918V14.9H134.758V16.9H131.918V23H129.718V9ZM136.993 9H140.253C141.386 9 142.213 9.26667 142.733 9.8C143.253 10.32 143.513 11.1267 143.513 12.22V13.08C143.513 14.5333 143.033 15.4533 142.073 15.84V15.88C142.606 16.04 142.98 16.3667 143.193 16.86C143.42 17.3533 143.533 18.0133 143.533 18.84V21.3C143.533 21.7 143.546 22.0267 143.573 22.28C143.6 22.52 143.666 22.76 143.773 23H141.533C141.453 22.7733 141.4 22.56 141.373 22.36C141.346 22.16 141.333 21.8 141.333 21.28V18.72C141.333 18.08 141.226 17.6333 141.013 17.38C140.813 17.1267 140.46 17 139.953 17H139.193V23H136.993V9ZM139.993 15C140.433 15 140.76 14.8867 140.973 14.66C141.2 14.4333 141.313 14.0533 141.313 13.52V12.44C141.313 11.9333 141.22 11.5667 141.033 11.34C140.86 11.1133 140.58 11 140.193 11H139.193V15H139.993ZM145.459 9H147.659V23H145.459V9ZM152.807 23.2C151.754 23.2 150.947 22.9 150.387 22.3C149.84 21.7 149.567 20.8533 149.567 19.76V12.24C149.567 11.1467 149.84 10.3 150.387 9.7C150.947 9.1 151.754 8.8 152.807 8.8C153.86 8.8 154.66 9.1 155.207 9.7C155.767 10.3 156.047 11.1467 156.047 12.24V13.72H153.967V12.1C153.967 11.2333 153.6 10.8 152.867 10.8C152.134 10.8 151.767 11.2333 151.767 12.1V19.92C151.767 20.7733 152.134 21.2 152.867 21.2C153.6 21.2 153.967 20.7733 153.967 19.92V17.78H156.047V19.76C156.047 20.8533 155.767 21.7 155.207 22.3C154.66 22.9 153.86 23.2 152.807 23.2ZM159.463 9H162.443L164.723 23H162.523L162.123 20.22V20.26H159.623L159.223 23H157.183L159.463 9ZM161.863 18.36L160.883 11.44H160.843L159.883 18.36H161.863Z",
    fill: "#3DC8F9"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5117 30H165.411",
    stroke: "#3DC8F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicloud);
export default __webpack_public_path__ + "static/media/unicloud.2581fc0be8f5f63cfa49a9f192ede93f.svg";
export { ForwardRef as ReactComponent };